import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Container, useTheme, useMediaQuery } from '@mui/material';
import { MainLayout } from '../components/Layout';
import { DashboardHeader } from '../components/dashboard/common';
import TLIndividualLiveFeed from '../components/dashboard/TLIndividualLiveFeed';
import MBFDashboardAPIs from '../utilities/api/dashboard/MBFDashboardAPIs';

const TLLiveDashboard = ({ collapsed, setCollapsed }) => {
    const { user } = useSelector((state) => state.user.user);
    const [lastUpdated, setLastUpdated] = useState('');
    const [selectedTL, setSelectedTL] = useState('2'); // Default to Site 2 (IIT Bombay) for this demo
    const [tlOptions, setTLOptions] = useState([]);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        const fetchTLList = async () => {
            try {
                const response = await MBFDashboardAPIs.getTLList();
                const options = (response || []).map(tl => ({
                    id: tl.id?.toString() || '',
                    name: tl.name || ''
                })).filter(tl => tl.name !== 'MBF Admin');
                setTLOptions(options);
            } catch (error) {
                console.error('Error fetching TL list:', error);
            }
        };
        fetchTLList();
    }, []);

    useEffect(() => {
        updateTimestamp();
        const interval = setInterval(updateTimestamp, 60000);
        return () => clearInterval(interval);
    }, []);

    const updateTimestamp = () => {
        const now = new Date();
        setLastUpdated(now.toLocaleString('en-US', {
            month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true
        }));
    };

    const handleTLChange = (tlId) => {
        setSelectedTL(tlId);
    };

    return (
        <MainLayout collapsed={collapsed} setCollapsed={setCollapsed}>
            <Box sx={{ flexGrow: 1, overflowY: 'auto', bgcolor: '#f5f5f5', p: { xs: 1, md: 3 } }}>
                <Container maxWidth="xl">
                    <DashboardHeader
                        title="Live TL Monitoring"
                        lastUpdated={lastUpdated}
                        showSelector={true}
                        selectorLabel="Select Site"
                        selectorOptions={tlOptions}
                        selectedOption={selectedTL}
                        onOptionChange={handleTLChange}
                        onRefresh={() => window.location.reload()}
                    />

                    <Box sx={{ bgcolor: '#fff', borderRadius: '24px', p: { xs: 2, md: 4 }, boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}>
                        <TLIndividualLiveFeed siteId={selectedTL} />
                    </Box>
                </Container>
            </Box>
        </MainLayout>
    );
};

export default TLLiveDashboard;
